























































import DictMixin from '@/mixins/dict-mixin';
import { RuleActionDto } from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop } from 'vue-property-decorator';
import RuleActionItem from './rule-action-item.vue';
@Component({
  components: { RuleActionItem }
})
export default class RuleFormTab2Action extends mixins(DictMixin) {
  @PropSync('ruleActions') syncRuleActions!: RuleActionDto[];
  @Prop() ruleName!: string;
  @Prop() entity!: any[];

  get type0List() {
    let arr: RuleActionDto[] = [];
    this.syncRuleActions.forEach((v: RuleActionDto, index) => {
      if (v.actionCondition === 0) {
        arr.push({ ...v, index });
      }
    });
    return arr;
  }
  set type0List(value: RuleActionDto[]) {}

  get type1List() {
    let arr: RuleActionDto[] = [];
    this.syncRuleActions.forEach((v: RuleActionDto, index) => {
      if (v.actionCondition === 1) {
        arr.push({ ...v, index });
      }
    });
    return arr;
  }
  set type1List(value) {}

  visible = false;

  actionItem: RuleActionDto = {};

  openDraw(actionCondition: number) {
    this.actionItem = {
      actionName: this.ruleName,
      actionCondition
    };
    this.visible = true;
  }

  edit(record: RuleActionDto) {
    this.actionItem = record;
    this.visible = true;
  }

  remove(record: any) {
    this.syncRuleActions.splice(record.index, 1);
  }

  confirm(action: RuleActionDto) {
    if (action.index !== undefined) {
      this.syncRuleActions[action.index] = action;
    } else {
      this.syncRuleActions.push(action);
    }
  }
}
